import { instance } from "../api-instance";

export const FinancingApi = {
  getPaymentFrame(id: string): Promise<unknown> {
    return instance
      .get(`financing/addCardFrame?applicationId=${id}`)
      .then((res) => res.data);
  },

  getApproveStatus(guid: string): Promise<unknown> {
    const params = new URLSearchParams();
    params.append("financingInstrumentId", guid);
    return instance
      .get(`financing/approvedStatus?${params.toString()}`)
      .then((res) => res.data);
  },

  saveFinInstrumentToApplication(data: unknown): Promise<unknown> {
    return instance
      .post(`financing/saveToApplication`, data)
      .then((res) => res.data);
  },

  getFinancingInstruments(): Promise<unknown> {
    return instance
      .post(`financing/availableInstruments`)
      .then((res) => res.data);
  },

  checkIfHasSynonim(id: string): Promise<unknown> {
    const params = new URLSearchParams();
    params.append("financingInstrumentId", id);
    return instance
      .get(`financing/hasSynonim?${params.toString()}`)
      .then((res) => res.data);
  },

  getSynonim(data: unknown): Promise<unknown> {
    return instance.post("financing/getSynonim", data).then((res) => res.data);
  },
};
